import type { ITrainingEditorSectionSetup, TTrainingSharedFormValues } from "./types";

export const createTrainingSharedDefaultValues = (): TTrainingSharedFormValues => ({
  name: "",
  period: null,
  validation: "",
  wage: "",
  description: {
    html: "<p>Pr&eacute;sentation:</p>\n<p><br><br></p>\n<p>Objectifs:</p>",
    text: "Présentation: \n\n Objectifs:",
  },
  beneficiaries: { html: "", text: "" },
  trainingModalities: { html: "", text: "" },
  financingModes: { html: "", text: "" },
  registrationModalities: {
    html: "<ul>\n<li>D&eacute;marches r&eacute;f&eacute;rent :</li>\n</ul>\n<p>&nbsp;</p>\n<ul>\n<li>D&eacute;marche b&eacute;n&eacute;ficiaires :</li>\n</ul>\n<p>&nbsp;</p>\n<ul>\n<li>Documents &agrave; fournir :</li>\n</ul>",
    text: "Démarches référent : \n\n Démarche bénéficiaires : \n\n Documents à fournir :",
  },
  url: "",
  structureName: "",
  address: null,
  remote: null,
  structureWebsite: "",
  contact: null,
});

export const TRAINING_OFFER_EDITOR_SECTIONS: readonly ITrainingEditorSectionSetup[] = [
  {
    id: "training-offer-form-presentation",
    name: "description",
    height: 280,
    title: "Présentation",
    initialValue: "<p>Pr&eacute;sentation:</p><p><br><br></p><p>Objectifs:</p>",
  },
  {
    id: "training-offer-form-specification",
    name: "trainingModalities",
    height: 140,
    title: "Quelles sont les spécificités de rythme de la formation (durée, rythme...) ?",
  },
  {
    id: "training-offer-form-prerequisite",
    name: "beneficiaries",
    height: 140,
    title: "Quels sont les prérequis pour suivre cette formation ?",
  },
  {
    id: "training-offer-form-financing",
    name: "financingModes",
    height: 140,
    title: "Financements",
  },
  {
    id: "training-offer-form-subscription",
    name: "registrationModalities",
    height: 240,
    title: "Comment s'inscrire ?",
    urlLabel: "Lien URL où retrouver l’offre",
  },
];

export const TRAINING_APPLY_EDITOR_SECTIONS: readonly ITrainingEditorSectionSetup[] = [
  {
    id: "training-apply-form-presentation",
    name: "description",
    height: 280,
    title: "Présentation",
    initialValue: "<p>Pr&eacute;sentation:</p><p><br><br></p><p>Objectifs:</p>",
  },
  {
    id: "training-apply-form-specification",
    name: "trainingModalities",
    height: 140,
    title: "Quelles sont les spécificités de rythme de la formation (durée, rythme...) ?",
  },
  {
    id: "training-apply-form-prerequisite",
    name: "beneficiaries",
    height: 140,
    title: "Quels sont les prérequis pour suivre cette formation ?",
  },
  {
    id: "training-apply-form-financing",
    name: "financingModes",
    height: 140,
    title: "Financements",
  },
  {
    id: "training-apply-form-subscription",
    name: "registrationModalities",
    height: 240,
    title: "Comment s'inscrire ?",
    urlLabel: "Lien URL où retrouver l’offre",
  },
];
